module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "betting-container"
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "name": "tab_betting",
      "selected": "true"
    }
  }, [_c('div', {
    staticClass: "tab-details"
  }, [_c('div', {
    staticClass: "betting-balls"
  }, [_c('div', {
    staticClass: "future-bets"
  }, [_c('futurebets')], 1), _vm._v(" "), _c('div', {
    staticClass: "balls-container"
  }, _vm._l((_vm.balls), function(ball) {
    return _c('ball', {
      key: ball.number,
      attrs: {
        "ball": ball
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "additional-betting"
  }, [_c('div', {
    staticClass: "system-betting"
  }, [_c('button', {
    staticClass: "btn system-btn",
    attrs: {
      "disabled": _vm.isBettingDisabled('system')
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("translate")('select_system')))]), _vm._v(" "), (_vm.bettingSvc.type == 'system' || _vm.gameSvc.spotNumber < _vm.bettingSvc.ticket.input.length) ? _c('span', [_vm._v("\n                " + _vm._s(_vm.setActiveSystem) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn popup-btn",
    attrs: {
      "disabled": _vm.isBettingDisabled('system')
    },
    on: {
      "click": function($event) {
        _vm.openModal('system')
      }
    }
  }, [_c('span', {
    staticClass: "n-i n-i-arrow-down-a"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "random-betting"
  }, [_c('button', {
    staticClass: "btn random-btn",
    on: {
      "click": function($event) {
        _vm.selectRandom()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.setRandomLabel) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn popup-btn",
    on: {
      "click": function($event) {
        _vm.openModal('random')
      }
    }
  }, [_c('span', {
    staticClass: "n-i n-i-arrow-down-a"
  })])]), _vm._v(" "), ('i' in _vm.specialBets && _vm.specialBets.i.active) ? _c('div', {
    staticClass: "all-in-betting"
  }, [_c('button', {
    staticClass: "btn all-in-btn",
    class: {
      'active': _vm.bettingSvc.specialBetsActiveStatus[41]
    },
    attrs: {
      "id": "41",
      "disabled": _vm.isBettingDisabled('allIn')
    },
    on: {
      "click": _vm.specialClick
    }
  }, [_vm._v("\n              " + _vm._s(_vm.gameConfig.bets[41].name) + "\n            ")])]) : _vm._e(), _vm._v(" "), ('u' in _vm.specialBets && _vm.specialBets.u.active) ? _c('div', {
    staticClass: "no-draw-betting"
  }, [_c('button', {
    staticClass: "btn no-draw-btn",
    class: {
      'active': _vm.bettingSvc.specialBetsActiveStatus[40]
    },
    attrs: {
      "id": "40",
      "disabled": _vm.isBettingDisabled('noDraw')
    },
    on: {
      "click": _vm.specialClick
    }
  }, [_vm._v("\n              " + _vm._s(_vm.gameConfig.bets[40].name) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "paytable"
  }, [_c('paytable')], 1)])]), _vm._v(" "), (_vm.specialBetsFiltered) ? _c('tab', {
    attrs: {
      "name": "tab_special"
    }
  }, [_c('div', {
    staticClass: "tab-details"
  }, _vm._l((_vm.specialBetsFiltered), function(bet, index) {
    return _c('div', {
      key: index,
      staticClass: "special-bet"
    }, [_c('div', {
      staticClass: "special-bet-name"
    }, [_vm._v("\n            " + _vm._s(bet.name) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "special-actions clearfix"
    }, _vm._l((bet.actions), function(action, index) {
      return _c('div', {
        key: index,
        class: ("action action-" + (bet.actions.length)),
        attrs: {
          "id": ("choice-" + index + "-betId-" + (bet.id))
        },
        on: {
          "click": function($event) {
            _vm.selectChoice(bet, index)
          }
        }
      }, [_c('div', {
        staticClass: "span-wrap"
      }, [_c('span', {
        staticClass: "middle"
      }, [_vm._v("\n                  " + _vm._s(action.info.split(' - ')[1]) + "\n                ")])])])
    }))])
  }))]) : _vm._e()], 1), _vm._v(" "), (_vm.isModalVisible) ? _c('modal', {
    attrs: {
      "type": _vm.type
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1428972d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/terminal/main/Betting.vue
// module id = 397
// module chunks = 0